import * as yup from 'yup';

export const eduzzSchema = yup.object().shape({
  api_key: yup.string().required('Este campo é obrigatório.'),
  public_key: yup.string().required('Este campo é obrigatório.'),
  origin_key: yup.string().required('Este campo é obrigatório.'),
  email: yup.string().required('Este campo é obrigatório.'),
});
